namespace Roodik.Core
{
	export abstract class Advertisment implements IAdvertisment
	{
		protected _pauseGameEvent = new EventDispatcher<void>();
		protected _resumeGameEvent = new EventDispatcher<void>();

		constructor()
		{

		}

		public get pauseGameEvent():IEventDispatcher<void>
		{
			return this._pauseGameEvent.expose();
		}
		public get resumeGameEvent():IEventDispatcher<void>
		{
			return this._resumeGameEvent.expose();
		}

		public abstract show(force:boolean);
		public abstract fetch();
		public abstract get available():boolean;
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Advertisment/Advertisment.ts